import React, { useState, useEffect, useRef } from 'react';

import Modal from 'react-bootstrap/Modal';
import { FaEdit } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import MaskedInput from 'react-text-mask';
// import DatePicker from 'react-datepicker';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import {
  format,
  formatDistance,
  formatRelative,
  subYears,
  addDays,
  isValid,
} from 'date-fns';
// import 'react-datepicker/dist/react-datepicker.css';
//import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import Bunexe_service from '../../Bunexe_service';

import { useHistory } from 'react-router-dom';

const EditEcole = ({
  setTexte_Recherche,
  setEcole_selectionne,
  ecole_selectionne,
  info_={info_}
}) => {
  const nomref = useRef();
  //   const [ecole_selectionne, setEcole_selectionne] = useState(
  //     Bunexe_service.ecole_selection
  //   );
  //let ecole_selectionne = Bunexe_service.ecole_selection;
  //   alert(`${JSON.stringify(ecole_selectionne)}`);
  const [show, setShow] = useState(false);
  const [adresse, setAdresse] = useState(ecole_selectionne.AdresseEt);
  const [libelle_Et, setLibelle_Et] = useState(ecole_selectionne.LibelleEt);
  const [district, setDistrict] = useState(ecole_selectionne.District?ecole_selectionne.District:null);
  const [siege, setSiege] = useState(ecole_selectionne.CodeSiege?ecole_selectionne.CodeSiege:null);
  const [zone, setZone] = useState(ecole_selectionne.Zone?ecole_selectionne.Zone:null);
  const [directeur, setDirecteur] = useState(ecole_selectionne.Directeur);
  const [ecole_selectionnee_temp, setEcole_selectionnee_temp] = useState({
    ...ecole_selectionne,
  });
  const [listedistricts, setListredistricts] = useState([]);
  
  const [liste_sieges,setListeSieges] = useState([])

  let url_ = Bunexe_service.url;
  //'http://localhost:8086';

  const init = (ecole_selectionne) => {
    setAdresse(ecole_selectionne.AdresseEt);
    setLibelle_Et(ecole_selectionne.LibelleEt);
    setDistrict(ecole_selectionne.District?ecole_selectionne.District:"000000");
    setSiege(ecole_selectionne.CodeSiege?ecole_selectionne.CodeSiege:"0000");
    setZone(ecole_selectionne.Zone?ecole_selectionne.Zone:"000");
    setDirecteur(ecole_selectionne.Directeur);
  };

  const handleClose = () => {
    //setTexte_Recherche('');
    //setEcole_selectionne({});
    setShow(false);
  };
  const handleShow = () => {
    // setTexte_Recherche('');
    setShow(true);
  };

  const [sec_commune_nais, setSec_commune_nais] = useState({
    codeSec: '',
    libelleSec: '',
  });

  const getAllDistricts = async () => {
    try {
      fetch(
        url_ +
          `/statistique/9af/${ecole_selectionne.Code_direction}/district/all_district`
      )
        .then((response) => response.json())
        .then((data) => {
          setListredistricts(data);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  /** get All Sieges */
  const getAllSieges = async () => {
    try {
      fetch(
        url_ +
          `/statistique/9af/${ecole_selectionne.Code_direction}/siege/all_sieges`
      )
        .then((response) => response.json())
        .then((data) => {
          setListeSieges(data);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };
  /*
  const rechercher_commune = async (code_commune) => {
    try {
      fetch(url_ + `/commune/${code_commune}`)
        .then((response) => response.json())
        .then((data) => {
          setListeCommune(data);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };
  const section_communale_selectionnee = (c) => {
    setCommune(c.CodeSec);
    setListeCommune([]);
  };

  const getSectionCommunale = async () => {
    try {
      fetch(url_ + `/commune/sectionCommunale/sections`)
        .then((response) => response.json())
        .then((data) => {
          setListeCommune(data);
          setListeCommuneTemp(data);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };
*/
  const submitform = (e) => {
    e.preventDefault();

    //console.log(`username ${username} et password:${password}`);
    let mydata = {
      Ecole: ecole_selectionne.Ecole,
      LibelleEt: libelle_Et.replace("'", "''"),
      AdresseEt: adresse.replace("'", "''"),
      District: district,
      CodeSiege:siege,
      Zone: zone,
      Directeur: directeur.replace("'", "''"),
      utilisateur_:info_.username
    };
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mydata),
    };
    try {
      fetch(
        url_ + `/ecole/edit_ecole/${ecole_selectionne.Ecole}`,
        requestOptions
      )
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            //afficherMessage(data.message);
          } else {
            //  listeEleves_func(Ecole);

            // reload_List();
            setShow(false);
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }
  };
  useEffect(() => {
   // console.log(ecole_selectionne);

    init(ecole_selectionne);
    getAllDistricts();
    getAllSieges()
  }, [ecole_selectionne.Ecole]);
  return (
    <>
      {/* <Button variant='primary' onClick={handleShow}>
        edit
      </Button> */}
      <button onClick={handleShow} className='btn btn-primary btn-small'>
        {' '}
        Modifier Ecole
      </button>
      {/* <FaEdit onClick={handleShow} /> */}

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Modification Ecole</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='container mx-auto'>
            <div className='row'>
              <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 border rounded py-2'>
                {/* <h2 className='text-center'>{InfoEcole.LibelleEt}</h2>
                <h4 className='text-center'>{InfoEcole.AdresseEt}</h4> */}
                <h6 className='text-center'>{ecole_selectionne.Ecole}</h6>
                <hr />

                <Form autoComplete='off' noValidate onSubmit={submitform}>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridNom'>
                      <Form.Label>Directeur</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Directeur Ecole'
                        value={directeur}
                        // ref={nomref}
                        name='directeur'
                        //   onFocus={(e) => listeEleves_func(Ecole)}
                        onChange={(e) => setDirecteur(e.target.value)}
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridNom'>
                      <Form.Label>Etablissement</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Nom Ecole'
                        value={libelle_Et}
                        // ref={nomref}
                        name='etablissement'
                        //   onFocus={(e) => listeEleves_func(Ecole)}
                        onChange={(e) => setLibelle_Et(e.target.value)}
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridNom'>
                      <Form.Label>Adresse</Form.Label>
                      <Form.Control
                        type='text'
                        placeholder='Adresse Ecole'
                        value={adresse}
                        // ref={nomref}
                        name='adresse'
                        //   onFocus={(e) => listeEleves_func(Ecole)}
                        onChange={(e) => setAdresse(e.target.value)}
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridNom'>
                      <Form.Label>Siege</Form.Label>
                      <Form.Control
                        as='select'
                        placeholder='siege ..'
                        value={siege}
                        // ref={nomref}
                        name='siège'
                        //   onFocus={(e) => listeEleves_func(Ecole)}
                        onChange={(e) => setSiege(e.target.value)}
                      >
                        <option value={'0000'}>
                            {`Choisir un Siège`}
                          </option>
                        {liste_sieges.map((s, index) => (
                          <option key={index} value={s.IDSIEGE}>
                            {s.libelle_siege}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                   

                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridNom'>
                      <Form.Label>District</Form.Label>
                      <Form.Control
                        as='select'
                        placeholder='District Ecole'
                        value={district}
                        // ref={nomref}
                        name='district'
                        //   onFocus={(e) => listeEleves_func(Ecole)}
                        onChange={(e) => setDistrict(e.target.value)}
                      >
                        <option value={'000000'}>
                            {`Choisir un District`}
                          </option>
                        {listedistricts.map((s, index) => (
                          <option key={index} value={s.CodeDistrict}>
                            {s.libelle_district}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridNom'>
                      <Form.Label>Zone</Form.Label>
                      <Form.Control
                        as='select'
                        // placeholder='Zone Ecole'
                        value={zone}
                        // ref={nomref}
                        name='zone'
                        //   onFocus={(e) => listeEleves_func(Ecole)}
                        onChange={(e) => setZone(e.target.value)}
                      >
                        <option value={'000'}>
                            {`Choisir une Zone`}
                          </option>
                        {Bunexe_service.zones.map((s, index) => (
                          <option key={index} value={s.code}>
                            {s.libelle}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form>

                {/* {message && message.length > 0 && <small>{message}</small>} */}
              </div>
            </div>
          </div>
          {/* Woohoo, you're reading this text in a modal! */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Fermer
          </Button>
          <Button variant='primary' onClick={submitform}>
            Modifier
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditEcole;
